import { FC } from 'react'
import type { IconProps } from '../types'

// prettier-ignore
const StatusReviewCheckingIcon: FC<IconProps> = ({ size = 24 }) => (
  <svg
    width={size}
    height={size}
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M9.3125 17.75L7.0625 20L4.8125 17.75H2V4.25H20V9M6.5 13.25H9.875M6.5 8.75H13.25'
      stroke='#A0A1AD'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M12 18C12 14.688 14.688 12 18 12C21.312 12 24 14.688 24 18C24 21.312 21.312 24 18 24C14.688 24 12 21.312 12 18ZM17.6688 19.0962L20.3356 20.4293C20.665 20.5943 21.065 20.4606 21.23 20.1312C21.3943 19.8018 21.2612 19.4018 20.9318 19.2369L18.6338 18.0881V15.1669C18.6338 14.7987 18.335 14.5 17.9669 14.5C17.5988 14.5 17.3 14.7987 17.3 15.1669V18.5C17.3 18.7525 17.4432 18.9831 17.6688 19.0962Z'
      fill='#3B42A5'
    />
  </svg>
)

export default StatusReviewCheckingIcon
